import { SectionTitle } from "../../components/common/SectionTitle";
import { stylists } from "../../data/siteData";

export function StylistsSection() {
  const isSolo = stylists.length === 1;
  const subtitle = isSolo ? "Meet the Artist" : "Meet the Artists";
  const title = isSolo ? "The Founder" : "Our Master Stylists";

  return (
    <section id="stylists" className="site-section">
      <div className="container">
        <SectionTitle subtitle={subtitle} title={title} />

        <div className="card-grid card-grid--stylists">
          {stylists.map((stylist) => (
            <article key={stylist.id} className="image-card scroll-reveal">
              <div className="image-card__media">
                <img src={stylist.img} alt={stylist.name} loading="lazy" />
              </div>
              <div className="image-card__overlay founder-card__overlay">
                <h3 className="image-card__title">{stylist.name}</h3>
                <p className="body-copy body-copy--tight founder-card__title">{stylist.title}</p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
